import React from 'react';
import { PiArrowLeft, PiFloppyDiskDuotone } from 'react-icons/pi';
import { Text } from 'src/modules/shared/components/atoms/text';
import Button from 'src/modules/shared/components/atoms/buttons/button';

type WorkflowEditorHeaderActionsProps = {
  onBack: () => void;
  onSave: () => void;
  canSave?: boolean;
  isSaving?: boolean;
};

export const WorkflowEditorHeaderActions: React.FC<
  WorkflowEditorHeaderActionsProps
> = ({ onBack, onSave, canSave = false, isSaving = false }) => (
  <div className="flex items-center gap-2">
    <Button variant="neutral" appearance="ghost" size="md" onClick={onBack}>
      <div className="flex items-center gap-2">
        <PiArrowLeft className="w-4 h-4" />
        <Text size="small">Volver</Text>
      </div>
    </Button>
    <Button
      variant="primary"
      size="md"
      onClick={onSave}
      disabled={!canSave}
      loading={isSaving}
    >
      <div className="flex items-center gap-2">
        <PiFloppyDiskDuotone className="w-4 h-4" />
        <Text size="small">Guardar</Text>
      </div>
    </Button>
  </div>
);

export default WorkflowEditorHeaderActions;
